import React, { useState, useEffect } from "react";
import jwtDecode from "jwt-decode";
import moment from "moment";
import * as XLSX from "xlsx";

import CustomTable from "../../../components/table/table";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CommonForm from "../../../components/commonform/commonForm";
import { user_company_list, super_comp_delete, admin_csv } from "../admin.api";
import { statusRegType } from "../../../components/table/store";
import "./view.css";

const getStatusInfo = (status) => {
  const statusMap = {
    0: { label: "Pending", class: "pending", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    1: { label: "Submitted", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg> },
    2: { label: "Accepted", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
    3: { label: "SA Reverted", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> },
    4: { label: "Rejected", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> },
    5: { label: "Reverted", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v4m0 4h.01"></path></svg> },
  };
  return statusMap[status] || { label: "Unknown", class: "secondary", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> };
};

export default function View(props) {
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(9);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [upl, setUpl] = useState(false);
  const [file, setFile] = useState({ file_name: "" });

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [showFilters, setShowFilters] = useState(false);

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleListData = () => {
    setIsActive(true);
    let param = {
      type: "international",
      status: status === 9 ? "" : status,
      isadmin: 1,
      page: page,
      per_page: perPage,
    };
    user_company_list(param, adminType).then((resp) => {
      // Handle different API response structures (res.data vs res as array)
      const rawData = resp?.data || (Array.isArray(resp) ? resp : []);

      if (rawData && Array.isArray(rawData)) {
        rawData.forEach((item, index) => {
          item["slno"] = (page - 1) * perPage + index + 1;
        });
        setData(rawData);

        // Handle pagination from root or nested object
        const lastPage = resp?.last_page || resp?.pagination?.last_page || 1;
        setTotalPages(lastPage);
      } else {
        setData([]);
      }
      setIsActive(false);
    }).catch(() => {
      setData([]);
      setIsActive(false);
    });
  };

  useEffect(() => {
    handleListData();
  }, [page, perPage, status]);

  const handleEdit = (data) => {
    props.history.push("/edit-application-international/" + data.user_id);
  };

  const handleView = (data) => {
    props.history.push("/view-application-international/" + data.user_id);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    super_comp_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
        handleListData();
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleListData();
    }
  };

  const handleNew = () => {
    props.history.push("/newrequest-application-international");
  };

  const handleChangeStatus = (e) => {
    setStatus(Number(e.target.value));
    setPage(1);
  };

  const handlePerPageChange = (e) => {
    setPerPage(parseInt(e.target.value));
    setPage(1);
  };

  const handleFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();

    if (["xls", "xlsx", "ods"].includes(type?.toLowerCase())) {
      let mb = size / Math.pow(1024, 2);
      if (mb < 5) {
        setFile({
          file_name: e.target.files[0].name,
          [e.target.name]: e.target.files[0],
        });
      } else {
        setSnackMessage("File size is greater than 5MB");
        setIsSnackError(true);
        setSnackOpen(true);
        setFile({ file_name: "", [e.target.name]: null });
      }
    } else {
      setSnackMessage("File should be in .xls , .xlsx format");
      setIsSnackError(true);
      setSnackOpen(true);
      setFile({ file_name: "", [e.target.name]: null });
    }
  };

  const handleCSVUpload = () => {
    if (!file.company_upload) {
      setSnackMessage("Please select a file first");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }
    const payload = new FormData();
    payload.append("file", file.company_upload);
    setIsActive(true);
    admin_csv(payload)
      .then(() => {
        setSnackMessage("CSV Uploaded Successfully");
        setIsSnackError(false);
        setSnackOpen(true);
        setFile({ file_name: "" });
        setUpl(false);
        setIsActive(false);
        handleListData();
      })
      .catch(() => {
        setSnackMessage("Something Went Wrong");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const downloadExcel = async () => {
    const exportData = await fetchExportData();
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Companies");
    XLSX.writeFile(workbook, "Companies-International.xlsx");
  };

  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item) => {
      exportdata.push({
        ["Company Name"]: item.company_name,
        ["Email"]: item.email,
        ["Phone Number"]: item.phone_no,
        ["POC"]: item?.person_name,
        ["Status"]: getStatusInfo(item.project_status ?? item.application_status).label,
        ["Created At"]: item.created_at ? moment(item.created_at).format("DD-MMM-YYYY") : "--",
      });
    });
    return exportdata;
  }

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);

    if (start > 1) {
      pages.push(<button key={1} className="btn btn-sm btn-outline-primary" onClick={() => setPage(1)}>1</button>);
      if (start > 2) pages.push(<span key="start-dots" className="px-1 text-primary">...</span>);
    }
    for (let i = start; i <= end; i++) {
      pages.push(
        <button key={i} className={`btn btn-sm ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`} onClick={() => setPage(i)}>
          {i}
        </button>
      );
    }
    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="end-dots" className="px-1 text-primary">...</span>);
      pages.push(<button key={totalPages} className="btn btn-sm btn-outline-primary" onClick={() => setPage(totalPages)}>{totalPages}</button>);
    }
    return pages;
  };

  return (
    <div className="container-fluid mt-4">
      <Loader open={isActive} />
      <Snackbar message={snackMessage} error={isSnackError} open={snackOpen} close={snackbarClose} />

      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <b>Companies in International</b>
          </h5>
          <div className="d-flex gap-2">
            {adminType === 1 && (
              <button className="btn btn-primary btn-sm" onClick={handleNew}>
                Add New Company
              </button>
            )}
            <button className={`btn btn-sm ${upl ? "btn-secondary" : "btn-outline-primary"}`} onClick={() => setUpl(!upl)}>
              {upl ? "Cancel Upload" : "Upload CSV"}
            </button>
            <button className="btn btn-outline-primary btn-sm" onClick={downloadExcel}>
              Download Excel
            </button>
            <button className={`filter-icon-btn ${showFilters ? "active" : ""}`} onClick={() => setShowFilters(!showFilters)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
              </svg>
            </button>
          </div>
        </div>

        <div className="card-body pt-0">
          <div className={`filter-container ${showFilters ? "show" : ""}`}>
            <div className="row align-items-end">
              <div className="col-md-4">
                <label className="form-label small">Status</label>
                <select className="form-control filter-select" value={status} onChange={handleChangeStatus}>
                  <option value={9}>All Statuses</option>
                  {statusRegType.map((item) => (
                    item.id !== 6 && item.id !== 5 && <option key={item.id} value={item.id}>{item.title}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-2 d-flex gap-2">
                <button className="filter-action-btn" title="Reset Filters" onClick={() => { setStatus(9); setPage(1); }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                    <path d="M3 3v5h5"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {upl && (
            <div className="alert alert-light border d-flex align-items-center gap-3 mb-4 mt-2">
              <div className="flex-grow-1">
                <CommonForm
                  fieldType="file"
                  required={true}
                  name="company_upload"
                  {...props}
                  className="p-0"
                  fileHeightAdjust={true}
                  id="company_upload"
                  fileName={file.file_name ?? "Upload file"}
                  accept=".xls,.xlsx"
                  type="file"
                  variant="outlined"
                  onChange={handleFileChange}
                />
              </div>
              <button className="btn btn-primary btn-sm px-4" onClick={handleCSVUpload}>
                Submit CSV
              </button>
            </div>
          )}

          <CustomTable
            {...props}
            columns={[
              // { title: "Sl No", field: "slno" },
              { title: "Company Name", field: "company_name" },
              { title: "Phone Number", field: "phone_no" },
              { title: "Email", field: "email" },
              {
                title: "Status",
                field: "project_status",
                render: (row) => {
                  const statusInfo = getStatusInfo(row.project_status ?? row.application_status);
                  return (
                    <span className={`status-badge ${statusInfo.class}`}>
                      <span className="status-icon">{statusInfo.icon}</span>
                      <span className="status-label">{statusInfo.label}</span>
                    </span>
                  );
                },
              },
              {
                title: "Action",
                render: (row) => (
                  <div className="d-flex gap-1">
                    <button className="btn btn-sm btn-outline-primary" onClick={() => handleView(row)}>View</button>
                    {(adminType === 1 || adminType === 2) && (
                      <button className="btn btn-sm btn-outline-secondary" onClick={() => handleEdit(row)}>Edit</button>
                    )}
                    {adminType === 2 && (
                      <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(row)}>Delete</button>
                    )}
                  </div>
                ),
              },
            ]}
            data={data}
            paging={false}
            options={{ search: true, selection: false, exportButton: false }}
          />

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="flex-grow-1"></div>
            <div className="btn-group">
              <button className="btn btn-sm btn-outline-primary" disabled={page === 1} onClick={() => setPage((p) => p - 1)}>Prev</button>
              {renderPagination()}
              <button className="btn btn-sm btn-outline-primary" disabled={page === totalPages} onClick={() => setPage((p) => p + 1)}>Next</button>
            </div>
            <div className="flex-grow-1 d-flex justify-content-end">
              <select className="form-control form-control-sm w-auto ml-2" value={perPage} onChange={handlePerPageChange} style={{ fontSize: "8px", height: "31px" }}>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
          </div>
        </div>

        {openAction && (
          <ConfirmDialog
            open={openAction}
            title="Delete Company?"
            data={activeData}
            message="Are you sure you want to delete this company?"
            secondary_action="Cancel"
            primary_action="Delete"
            handleClose={handleCancelDelete}
            handleConfirm={handleDeleteConfirm}
          />
        )}
      </div>
    </div>
  );
}
